import { useRole } from "../context/role/RoleContext";
import Unauthorized from "../utils/unaouthorized";

export const RoleRoute = ({ resourceName, resourceAction, children }) => {
  const { state } = useRole();
  const role = state?.role;

  const hasPermission = role?.[resourceName]?.[resourceAction];

  console.log(
    role?.[resourceName]?.[resourceAction],
    "role?.[resourceName]?.[resourceAction]"
  );

  return hasPermission ? <>{children}</> : <Unauthorized />;
};
